// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_di5","cls2":"FocusedNavView-cls2_Ffj FocusedNavView-cls1_di5"};